










































































































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import { RemoteData } from '@/modules/shared/helpers/http/remote-data' //todo: change file path
import { NotificationModel, NotificationModelType } from '@/modules/notification/models/notification.model'
import { Notification } from '@/modules/notification/services/notification.service'
import { Str } from '@/modules/shared/helpers'
import { DateHelper } from '@/modules/shared/helpers/date'
import NiknevisLogo from '@/modules/shared/components/shared/NiknevisLogo.vue'
import { NotificationApiRoute, NotificationRoute } from '@/modules/notification/routes/panelNotificationRoute'
import MarkAllAsReadButton from '@/modules/notification/components/shared/MarkAllAsReadButton.vue'

@Component({
  components: { MarkAllAsReadButton, NiknevisLogo }
})
export default class NotificationsBell extends Vue {
  constructor(
    private readonly str: Str,
    private readonly date: DateHelper,
    private readonly route: NotificationRoute,
    private readonly apiRoute: NotificationApiRoute
  ) {
    super()
  }

  @Prop() unreadNotifications!: number
  unreadCount = this.unreadNotifications
  openModal = false //notLoading on close
  modalLoading = false
  notIndex = false

  remoteData = RemoteData.notAsked<NotificationModelType>()

  updated() {
    this.notIndex = !window.location.href.includes('notifications/index')
  }

  private get list(): NotificationModel[] {
    return this.remoteData.fold(
      () => [],
      () => [],
      value => value.data,
      () => []
    )
  }

  private get readCount(): number | any {
    return this.remoteData.fold(
      () => [],
      () => [],
      value => value.read_count,
      () => []
    )
  }

  onClick() {
    this.openModal = !this.openModal
    if (this.openModal) {
      this.getList()
    }
  }

  getList() {
    this.modalLoading = true
    setTimeout(() => {
      this.remoteData.fromRemoteData(
        Notification.getList()
      ).then(() => {
        this.modalLoading = false
        this.unreadCount = (this.readCount) ? (this.unreadCount - this.readCount) : 0
      })
    }, 500)
  }

}
